/**
 * 注入配置向相关的变量
 */

export default function (injection, Vue) {
    const config = {
        errorCode: {
            ACCESS_TOKEN_EMPTY: 40000,
            ACCESS_TOKEN_EXPIRED: 40001,
            PERMISSION_DENIED: 50001,
            USER_NOT_FOUND: 50002,
            USER_NOT_SITE_USER: 50003,
            USER_EMAIL_USED: 50004,
            USER_IS_SITE_USER: 50005,
            CANNOT_DELETE_POST: 10001
        },
        errorText: {},
        getRootUrl () {
            if ('laravel' in window) {
                if ('app_url' in window.laravel) {
                    return window.laravel.app_url;
                }
            }
            return '';
        },
        webUrl: {},
        apiUrl: {
            sxGenRedirectUrl: '/sx/gen-redirect-uri',
            ystGenRedirectUrl: '/yst/gen-redirect-uri',
            unitList: '/unit/list',
            typeList: '/type/list',
            vericodeImage: '/vericode/image',
            letterAdd: '/letter/add',
            postDchsList: `/postmeta/i/${window.location.href.includes('gd.gov.cn') ? 32489 : 21926}.json`,
            postTopicList: `/postmeta/i/${window.location.href.includes('gd.gov.cn') ? 32571 : 21955}.json`,
            postExposureList: `/postmeta/i/${window.location.href.includes('gd.gov.cn') ? 38328 : 25830}.json`
        },
        opts: {},
        constance: {
            GD_SITE_ID: 2,
            isProduction: process.env.NODE_ENV === 'production'
        }
    };

    // 征集调查链接一共3种格式
    // http://cloudtest-site2.southcn.com/hdjlpt/yjzj/answer(result)/1487
    // http://yjzj.gd.gov.cn/answer/201#/answer/137
    // http://yjzj.gd.gov.cn/answer/201#/result/137
    const parseZjdcId = (str) => {
        if (!str) {
            return '';
        }

        var validPrefix = ['/hdjlpt/yjzj/', 'yjzj.gd.gov.cn/'];
        if (str.indexOf(validPrefix[0]) < 0 && str.indexOf(validPrefix[1]) < 0) { // 非法链接
            return '';
        }

        var tmpId = '';
        var strArr = str.split('/');
        if (strArr[strArr.length - 1] === '') { // 防止链接以"/"结尾
            if (!isNaN(strArr[strArr.length - 2]) && strArr[strArr.length - 2] !== '') {
                tmpId = strArr[strArr.length - 2];
            }
        } else if (!isNaN(strArr[strArr.length - 1])) {
            tmpId = strArr[strArr.length - 1];
        }

        return tmpId;
    };

    const myFuncs = {
        getUrlParams (urlStr) {
            if (typeof urlStr == 'undefined') {
                var url = decodeURIComponent(location.search);
            } else {
                var url = '?' + urlStr.split('?')[1];
            }
            var theRequest = new Object();
            if (url.indexOf('?') != -1) {
                var str = url.substr(1);
                let strs = str.split('&');
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
                }
            }
            return theRequest;
        },

        parseQueryString () {
            var str = window.location.search;
            var objURL = {};

            str.replace(
                new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                function ($0, $1, $2, $3) {
                    objURL[$1] = decodeURIComponent($3);
                }
            );
            return objURL;
        },

        generateUrlSearch (args) {
            var searchStr = '', firstKey = true;
            for (let key in args) {
                if (firstKey) {
                    firstKey = false;
                    searchStr += '?' + key + '=' + encodeURIComponent(args[key]);
                } else {
                    searchStr += '&' + key + '=' + encodeURIComponent(args[key]);
                }
            }
            return searchStr;
        },

        htmlToPlain (str) {
            if (!str) {
                return '';
            }

            var $div = document.createElement('div');
            $div.innerHTML = str;
            return $div.innerText;

            str = str || '';
            let regex = /<style[\s\S]*?<\/style>/ig;
            str = str.replace(regex, '');

            str = str.replace();
            str = str.replace(/<\/?.+?>/g, '');
            str = str.replace(/ /g, '');
            return str;
        },

        zjdc: {
            parseId: (str) => {
                if (!str) {
                    return '';
                }

                var validPrefix = ['/hdjlpt/yjzj/', 'yjzj.gd.gov.cn/'];
                if (str.indexOf(validPrefix[0]) < 0 && str.indexOf(validPrefix[1]) < 0) { // 非法链接
                    return;
                }

                var tmpId = '';
                var strArr = str.split('/');
                if (strArr[strArr.length - 1] === '') { // 防止链接以"/"结尾
                    if (!isNaN(strArr[strArr.length - 2]) && strArr[strArr.length - 2] !== '') {
                        tmpId = strArr[strArr.length - 2];
                    }
                } else if (!isNaN(strArr[strArr.length - 1])) {
                    tmpId = strArr[strArr.length - 1];
                }
                return tmpId;
            },

            getIds: (arr) => {
                var tmpIds = [];
                if (arr && arr.length) {
                    for (var i = 0; i < arr.length; ++i) {
                        if (parseZjdcId(arr[i].url)) {
                            tmpIds.push(parseZjdcId(arr[i].url));
                        }
                    }
                }
                return tmpIds;
            },

            replaceStatus: (status) => {
                var statusText = '进行中';
                if (status === 'unpublished' || status === 'draft') {
                    statusText = '未开始';
                } else if (status === 'paused') {
                    statusText = '已暂停';
                } else if (status === 'finished') {
                    statusText = '已结束';
                }

                return statusText;
            }
        }
    };

    Object.defineProperties(Vue.prototype, {
        $config: {
            get () {
                return config;
            }
        },
        $myFuncs: {
            get () {
                return myFuncs;
            }
        }
    });

    Object.defineProperties(injection, {
        config: {
            get () {
                return config;
            }
        },
        myFuncs: {
            get () {
                return myFuncs;
            }
        }
    });
}
